module.exports = __webpack_public_path__ + "img/vd-milkshake.80cb4df8.svg";